import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "./utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-5 w-5 shrink-0 rounded-lg border-2 border-shire-bark/30 bg-white/90 shadow-inner backdrop-blur-sm transition-all duration-200 hover:border-shire-sun/50 hover:shadow-md focus-visible:border-shire-sun focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-shire-sun/20 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-shire-sun data-[state=checked]:bg-gradient-to-br data-[state=checked]:from-shire-sun data-[state=checked]:to-amber-400 data-[state=checked]:text-shire-dark",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="size-3.5 font-bold" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
